import { Box, Flex, styled } from '@ghq-abi/design-system';

export const StyledWrapper = styled(Flex, {
  pt: '$appHeaderHeight',
  minHeight: '100vh'
});

export const StyledContent = styled(Box, {
  flex: 1,
  maxWidth: '$full',
  p: '$md',
  display: 'flex',
  flexDirection: 'column',
  backgroundColor: '#FBFAFC',

  '@tabletSm': {
    p: '$8 $lg $lg calc($appMenuClosedWidth + $lg)'
  }
});
